import { mapState } from 'pinia'

import Gallery from 'src/components/gallery/gallery.vue'
import LinkPreview from 'src/components/link-preview/link-preview.vue'
import Poll from 'src/components/poll/poll.vue'
import StatusBody from 'src/components/status_body/status_body.vue'

import { useMergedConfigStore } from 'src/stores/merged_config.js'

const StatusContent = {
  name: 'StatusContent',
  props: {
    // see RichContent
    replyArrow: { type: Object, default: null },
    // see StatusBody
    withQuote: Boolean,
    status: {
      // Main thing
      type: Object,
      required: true,
    },
    compact: {
      // Resizes emoji and minimizes vertical space used
      // Primarily used for showing status in react notifications
      type: Boolean,
      default: false,
    },
    collapse: {
      // replaces newlines with spaces
      type: Boolean,
      default: false,
    },
    singleLine: {
      // Show entire thing (subject and content) in a single line
      // Primarily used in chats
      type: Boolean,
      default: false,
    },
    inConversation: {
      // Whether status content is being shown in an (open) conversation
      // Used to control whether to display attachments or not
      type: Boolean,
      default: false,
    },
  },
  emits: ['parseReady', 'mediaplay', 'mediapause'],
  computed: {
    statusCard() {
      if (!this.status.card) return null
      return this.status.card.url === this.status.quote_url
        ? null
        : this.status.card
    },
    attachmentSize() {
      if (this.compact) {
        return 'small'
      } else if (
        (this.mergedConfig.hideAttachments && !this.inConversation) ||
        (this.mergedConfig.hideAttachmentsInConv && this.inConversation)
      ) {
        return 'hide'
      }
      return 'normal'
    },
    maxThumbnails() {
      return this.mergedConfig.maxThumbnails
    },
    ...mapState(useMergedConfigStore, ['mergedConfig']),
  },
  components: {
    Poll,
    Gallery,
    LinkPreview,
    StatusBody,
  },
}

export default StatusContent
